import React from "react";

const ListValues: React.FC<{
  categoryItems: string[];
  className?: string;
  comma?: boolean;
  separator?: string;
  values?: string[];
}> = ({ categoryItems, className, comma = true, separator = ", ", values }) => {
  const itemsToDisplay = values
    ? values.filter((item: string) => categoryItems.includes(item))
    : categoryItems;

  return (
    <div>
      {itemsToDisplay.map((item: string, key: number) => {
        const displayItem = item === "onesize" ? "One Size" : item.toUpperCase();
        return (
          <span key={item} className={className}>
            {displayItem}
            {comma && itemsToDisplay.length !== ++key && separator}
          </span>
        );
      })}
    </div>
  );
};

export default ListValues;
